import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: 'AIzaSyDmi3uL-3oNn8ncpbuWALNl3NZGcitNPfw',
  authDomain: 'chefcoco-d8d7d.firebaseapp.com',
  projectId: 'chefcoco-d8d7d',
  storageBucket: 'chefcoco-d8d7d.appspot.com',
  messagingSenderId: '822614765451',
  appId: '1:822614765451:web:fcd6674f128eae91f3098e',
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

export default auth;